// extracted by mini-css-extract-plugin
export default {"iconLogo":"styles_iconLogo__c7Yy0","squareWrapper":"styles_squareWrapper__-tmEx"};